import React from "react";
import { useTranslation } from "react-i18next";
import { TableConfig } from "@components";
import { BankRowData } from "./types";
import { BankRow } from "./BankRow";

export const useTableConfig = () => {
  const { t } = useTranslation();
  return {
    id: "banks",
    showHeader: true,
    getRowId: (data) => data.depot?.name ?? data.account?.name,
    emptyText: t("csvImport.banksTable.emptyText"),
    columns: [
      {
        id: "depot",
        title: t("csvImport.banksTable.depot"),
        align: "left",
        renderer: ({ row }) => <BankRow bank={row.depot} />,
      },
      {
        id: "account",
        title: t("csvImport.banksTable.account"),
        align: "left",
        renderer: ({ row }) => <BankRow bank={row.account} />,
      },
    ],
  } as TableConfig<BankRowData>;
};
